/**
 *  @class
 *  @function ProductRecommendations
 */

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.parent = this.closest('.product-recommendations--parent');
    this.productsContainer = null;
    this.dots = [];
  }

  connectedCallback() {
    this.fetchProducts();
  }

  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          this.productsContainer = this.querySelector('.cart-drawer--recommendations--products');
          if (this.productsContainer) {
            this.generateDots();
            this.setupDots();
          }

          if (this.parent) {
            this.parent.classList.add('product-recommendations--full');

            if (document.body.classList.contains('open-cart')) {
              this.parent.classList.add('active');
            }
          }
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }

  generateDots() {
    if (!this.productsContainer) return;

    const items = this.productsContainer.children;
    if (!items.length) return;

    const dotsContainer = document.createElement('div');
    dotsContainer.classList.add('cart-drawer--recommendations--dots');

    Array.from(items).forEach((item, index) => {
      const dot = document.createElement('button');
      dot.className = 'dot';
      dot.dataset.index = index;

      if (index === 0) {
        dot.classList.add('active');
      }

      dotsContainer.appendChild(dot);
    });

    this.productsContainer.insertAdjacentElement('afterend', dotsContainer);
  }

  setupDots() {
    const dotsContainer = this.querySelector('.cart-drawer--recommendations--dots');
    if (!dotsContainer) return;

    this.dots = Array.from(dotsContainer.querySelectorAll('.dot'));
    const items = Array.from(this.productsContainer.children);

    // Click sur les dots
this.dots.forEach((dot, index) => {
  dot.addEventListener('click', () => {
    const item = items[index];
    if (!item) return;

    const containerRect = this.productsContainer.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();

    const computedStyle = window.getComputedStyle(this.productsContainer);
    const paddingLeft = parseInt(computedStyle.paddingLeft) || 16;

    const offset = item.offsetLeft - paddingLeft;
    const maxScroll = this.productsContainer.scrollWidth - this.productsContainer.clientWidth;
    const targetScroll = Math.min(offset, maxScroll);

    this.productsContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });

    this.setActiveDot(index);
  });
});

    // Scroll natif
    this.productsContainer.addEventListener('scroll', () => {
      const scrollLeft = this.productsContainer.scrollLeft;
      const itemWidth = items[0]?.offsetWidth || 1;
      const index = Math.round(scrollLeft / itemWidth);
      this.setActiveDot(index);
    });
  }

  setActiveDot(index) {
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);